var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_7081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.65846 18.3927C9.44753 19.2085 9.01154 19.9821 8.37859 20.615C6.9158 22.0638 1.50421 23.7904 0.899431 23.9732C0.660274 24.0435 0.393086 23.9732 0.210273 23.7903C0.0274601 23.6075 -0.0429932 23.3403 0.0274132 23.0871C0.210273 22.4964 1.95089 17.0987 3.39951 15.6361C4.03242 15.0031 4.806 14.5671 5.62181 14.3561L7.63308 16.3674L9.65846 18.3927Z",
    fill: "#FFE470"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63315 16.3674L9.65848 18.3927C9.44754 19.2085 9.01156 19.982 8.3786 20.615C6.91582 22.0637 1.50423 23.7903 0.899447 23.9731C0.66029 24.0435 0.393102 23.9731 0.210289 23.7903L7.63315 16.3674Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87229 17.1269L5.8891 19.124C5.74847 19.2506 5.56566 19.3209 5.39686 19.3209C5.214 19.3209 5.03119 19.2506 4.89047 19.124V19.11C4.62324 18.8287 4.62324 18.3926 4.89047 18.1254L6.88772 16.1422C7.15496 15.861 7.59099 15.861 7.85823 16.1422H7.87229C8.15349 16.4096 8.15349 16.8596 7.87229 17.1269Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87229 16.1424C8.15354 16.4096 8.15354 16.8597 7.87229 17.1269L5.8891 19.1241C5.74847 19.2507 5.56566 19.321 5.39686 19.321C5.214 19.321 5.03119 19.2507 4.89047 19.1241V19.11L7.85822 16.1423L7.87229 16.1424Z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17756 6.91635C3.18293 6.91635 1.6067 11.139 1.48024 11.2801C1.37036 11.4978 1.38067 11.7574 1.50906 11.9654C1.6368 12.1735 1.86344 12.3005 2.10789 12.3005C4.99437 12.5558 6.7954 12.715 6.6515 12.7022L9.04353 6.91626H8.17756V6.91635Z",
    fill: "#FF7816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2975 17.3401C11.3084 17.4841 11.661 22.1319 11.6382 21.8308C11.6382 22.3545 12.1913 22.6938 12.6587 22.4585C12.7995 22.3323 17.0224 20.726 17.0224 15.7612V14.8951L11.2975 17.3401Z",
    fill: "#FF4B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8667 18.1396C11.1212 18.5193 10.3758 18.8851 9.67253 19.2367C9.40529 19.3773 9.08185 19.321 8.85671 19.1101L4.89042 15.1438C4.67949 14.9188 4.62319 14.5953 4.76391 14.3281C5.11552 13.6248 5.48124 12.8793 5.86092 12.1339C6.08602 11.6979 7.71751 12.6684 7.9426 12.2183L11.7823 16.058C11.3322 16.283 12.3027 17.9146 11.8667 18.1396Z",
    fill: "#FF9F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8667 18.1395C11.1213 18.5193 10.3758 18.885 9.67254 19.2366C9.40531 19.3772 9.08187 19.321 8.85673 19.11L6.87363 17.1269L9.86947 14.1451L11.7823 16.058C11.3322 16.2829 12.3027 17.9145 11.8667 18.1395Z",
    fill: "#FF7816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.414 6.98612C22.7811 9.40535 21.6418 11.3744 19.8696 13.0763C17.802 15.0734 14.4967 16.8175 11.8666 18.1396L8.8708 15.1437L5.8609 12.1339C7.18301 9.50374 8.92714 6.18437 10.9243 4.13096C12.6261 2.3588 14.5952 1.2195 17.0145 0.586548L18.4349 1.10696C18.4631 2.33058 18.9553 3.44176 19.757 4.24337C20.5587 5.04507 21.6699 5.5374 22.8935 5.56548L23.414 6.98612Z",
    fill: "#ECECF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.414 6.98606C22.7811 9.40528 21.6418 11.3743 19.8695 13.0762C17.802 15.0734 14.4967 16.8174 11.8666 18.1395L8.87077 15.1437L19.757 4.24335C20.5587 5.04505 21.6699 5.53738 22.8935 5.56546L23.414 6.98606Z",
    fill: "#E2E2E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8161 6.18438C16.4518 4.82013 14.2155 4.82013 12.8512 6.18438C11.4869 7.56279 11.4869 9.77098 12.8512 11.1493V11.1634C14.2155 12.5277 16.4518 12.5277 17.8161 11.1634C19.1945 9.785 19.1945 7.56284 17.8161 6.18438Z",
    fill: "#76E2F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.414 6.98613C23.3014 6.98613 22.9779 6.97207 22.8654 6.97207C21.2479 6.94399 19.8134 6.29702 18.7585 5.24214C17.7037 4.18727 17.0566 2.75261 17.0285 1.13523C17.0285 1.02268 17.0145 0.699196 17.0145 0.586696C19.0117 0.066242 21.248 -0.0603676 23.3015 0.0240076C23.4844 0.0240076 23.6531 0.0943671 23.7798 0.22093C23.9063 0.347539 23.9767 0.516337 23.9767 0.699196C24.0609 2.75251 23.9203 4.98888 23.414 6.98613Z",
    fill: "#FF9F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8385 13.1465C11.5713 13.4278 11.1213 13.4278 10.854 13.1465C10.5727 12.8793 10.5727 12.4292 10.854 12.1619C11.1212 11.8807 11.5712 11.8807 11.8385 12.1619C12.1198 12.4291 12.1198 12.8793 11.8385 13.1465Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.414 6.98609C23.3014 6.98609 22.9779 6.97202 22.8654 6.97202C21.2479 6.94395 19.8134 6.29698 18.7585 5.2421L23.7797 0.220886C23.9062 0.347496 23.9766 0.516293 23.9766 0.699153C24.0609 2.75247 23.9203 4.98883 23.414 6.98609Z",
    fill: "#FF7816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8161 11.1634C16.4518 12.5276 14.2155 12.5276 12.8512 11.1634V11.1493L17.8161 6.18433C19.1945 7.56278 19.1945 9.78494 17.8161 11.1634Z",
    fill: "#25D9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8385 13.1465C11.5712 13.4278 11.1212 13.4278 10.854 13.1465L11.8385 12.1619C12.1198 12.4291 12.1198 12.8793 11.8385 13.1465Z",
    fill: "#444444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_7081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.62c984d074d03a6eb9f1519a4e34b58d.svg";
export { ForwardRef as ReactComponent };